export const SET_BATCH_DETAILS = "SET_BATCH_DETAILS";

export const GET_BATCH_RECORDS_BEGIN = "GET_BATCH_RECORDS_BEGIN";
export const GET_BATCH_RECORDS_SUCCESS = "GET_BATCH_RECORDS_SUCCESS";
export const GET_BATCH_RECORDS_FAILURE = "GET_BATCH_RECORDS_FAILURE";

export const CLEAR_LOGS_DATA = "CLEAR_LOGS_DATA";
